import React from 'react';

export default function TermsOfService() {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Agreement to Terms</h2>
            <p>
              By accessing our website and using our services, you agree to be bound by these Terms of Service 
              and our Privacy Policy. If you disagree with any part of these terms, you may not access our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Medical Disclaimer</h2>
            <p>
              The information provided on this website is for general informational purposes only and is not 
              intended as a substitute for professional medical advice, diagnosis, or treatment.
            </p>
            <ul className="list-disc pl-6 mt-4">
              <li>Always seek the advice of your physician or other qualified health provider</li>
              <li>Never disregard professional medical advice</li>
              <li>Never delay seeking medical advice because of something you read on this website</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Appointment Scheduling</h2>
            <p>
              While we offer online appointment scheduling, please note:
            </p>
            <ul className="list-disc pl-6 mt-4">
              <li>Appointment requests are subject to availability</li>
              <li>Emergency medical conditions require immediate emergency room care</li>
              <li>Cancellations must be made at least 24 hours in advance</li>
              <li>Repeated no-shows may result in scheduling restrictions</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Privacy & HIPAA</h2>
            <p>
              We are committed to protecting your privacy and maintaining the confidentiality of your medical information. 
              Our practices comply with HIPAA regulations and our Privacy Policy details how we handle your information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Website Use</h2>
            <p>Users of this website agree not to:</p>
            <ul className="list-disc pl-6 mt-4">
              <li>Use the website in any unlawful manner</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Transmit malicious software or harmful data</li>
              <li>Impersonate another person or entity</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="mt-4">
              <p>Frederick Metabolic & Primary Care Associates</p>
              <p>184 Thomas Johnson Drive, Suite 201</p>
              <p>Frederick, MD 21701</p>
              <p>Phone: 240-949-7519</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
} 